import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Toaster } from "sonner";
import api from "@/lib/api";
import AdminConsole from "@/pages/Admin";
import { OrganizerLogin } from "@/components/admin/AdminLogin";

const Denied = () => (
  <div className="min-h-screen min-h-dvh grid place-items-center bg-[#EDECE3] px-6" data-testid="organizer-denied">
    <div className="w-full max-w-sm bg-white/80 border border-white/60 rounded-3xl shadow-[0_8px_40px_rgba(26,46,38,0.08)] p-8 text-center">
      <div className="mx-auto grid place-items-center w-12 h-12 rounded-full bg-rose-100 text-rose-700 mb-5"><ShieldAlert size={22} /></div>
      <h1 className="font-serif text-2xl mb-2">Organizer Access Only</h1>
      <p className="text-sm text-muted-foreground mb-6">This account does not have permission to access the Organizer Control Center.</p>
      <a href="/guide" data-testid="organizer-denied-go-guide" className="inline-flex rounded-full bg-[#C86A51] text-white px-6 py-3 text-sm hover:opacity-90">Go to Guide Workspace</a>
    </div>
  </div>
);

/* /organizer — Organizer Control Center entrance. Session lives in an HttpOnly cookie; the server decides who is who. */
export default function Organizer() {
  const [params] = useSearchParams();
  const [who, setWho] = useState(null);
  const [status, setStatus] = useState(null);
  const [legacyKey, setLegacyKey] = useState("");
  const refresh = useCallback(async () => {
    const [w, s] = await Promise.all([api.get("/access/whoami"), api.get("/access/organizer/status")]);
    setWho(w.data); setStatus(s.data);
  }, []);
  useEffect(() => { refresh().catch(() => setWho({ organizer: false, guide: null })); }, [refresh]);
  const signOut = async () => { try { await api.post("/access/organizer/logout"); } catch {} setLegacyKey(""); refresh(); };
  if (!who) return <div className="min-h-screen grid place-items-center bg-[#EDECE3] text-sm text-muted-foreground" data-testid="organizer-loading">Checking access…</div>;
  if (who.organizer || legacyKey) return <AdminConsole legacyKey={legacyKey} onSignOut={signOut} />;
  if (who.guide) return <Denied />;
  return (
    <>
      <Toaster position="top-center" richColors />
      <OrganizerLogin status={status} emergency={params.get("emergency") === "1"} onAuthed={refresh} onLegacy={setLegacyKey} onSetupDone={refresh} />
    </>
  );
}
